<h2 mat-dialog-title translate>Collection Upload</h2>
<mat-dialog-content>
  <div id="upload-room">
    <span translate>Room:</span>
    <ng-container *ngIf="roomData?.data">
      <app-avatar [blob]="roomData.data.avatar"></app-avatar>
      <span class="room-name">{{ roomData?.data?.name }}</span>
    </ng-container>
    <span *ngIf="!roomData?.data" class="room-name">{{ data.roomId }}</span>
  </div>
  <div id="upload-path">
    <span translate>Path:</span>
    <div id="path-to-upload">
      <span *ngIf="data.pathToUpload" class="path">"/{{ data.pathToUpload }}/"</span>
      <span *ngIf="!data.pathToUpload" translate class="path">Drive Root</span>
    </div>
  </div>
  <div id="conflict-policy">
    <div translate>How to resolve file conflict:</div>
  </div>
  <mat-radio-group color="primary" [(ngModel)]="data.conflictPolicy">
    <mat-radio-button [value]="CONFLICT_POLICY.SKIP">
      <span translate>Skip</span>
    </mat-radio-button>
    <mat-radio-button [value]="CONFLICT_POLICY.OVERWRITE">
      <span translate>Overwrite</span>
    </mat-radio-button>
    <mat-radio-button [value]="CONFLICT_POLICY.RENAME">
      <span translate>Auto rename</span>
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="close()" translate>Cancel</button>
  <button mat-raised-button color="primary" (click)="send()" cdkFocusInitial translate>Start Upload</button>
</mat-dialog-actions>
